import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  paymentLinesHeader: { id: 'towingOrder.view.paymentLinesHeader', defaultMessage: 'Maksurivit' },
  automaticItemsNotice: {
    id: 'towingRecordItems.automaticItemsNotice',
    defaultMessage: 'Huom! Kuormakirjan automaattirivejä ei voi muokata sovelluksessa.',
  },
  discountItemName: { id: 'towingRecordItems.discountItemName', defaultMessage: 'Kokonaisalennus' },
  addItemGroupPlaceholder: { id: 'towingRecordItems.addItemGroupPlaceholder', defaultMessage: 'Lisää tuoteryhmä' },
  addItemPlaceholder: { id: 'towingRecordItems.addItemPlaceholder', defaultMessage: 'Lisää tuote' },
  addDiscount: { id: 'towingRecordItems.addDiscount', defaultMessage: 'Lisää alennus' },
  emptyRow: { id: 'towingRecordItems.emptyRow', defaultMessage: 'Tyhjä rivi' },
  pricesIncludeVat: { id: 'towingRecordItems.pricesIncludeVat', defaultMessage: 'Hinnat sis. ALV' },
  pricesExcludeVat: { id: 'towingRecordItems.pricesExcludeVat', defaultMessage: 'Hinnat ilman ALV' },
  itemName: { id: 'towingRecordItems.itemName', defaultMessage: 'Tuotenimike' },
  quantity: { id: 'towingRecordItems.quantity', defaultMessage: 'Määrä' },
  unit: { id: 'towingRecordItems.unit', defaultMessage: 'Yksikkö' },
  unitPrice: { id: 'towingRecordItems.unitPrice', defaultMessage: 'á-hinta' },
  discountPercent: { id: 'towingRecordItems.discountPercent', defaultMessage: 'Ale-%' },
  vatPercent: { id: 'towingRecordItems.vatPercent', defaultMessage: 'ALV-%' },
  total: { id: 'towingRecordItems.total', defaultMessage: 'Yhteensä' },
  discountTypeAmount: { id: 'towingRecordItems.discountTypeAmount', defaultMessage: '€ sis. ALV' },
  discountTypePercentage: { id: 'towingRecordItems.discountTypePercentage', defaultMessage: '%' },
  discount: { id: 'towingRecordItems.discount', defaultMessage: 'Alennus' },
  discountType: { id: 'towingRecordItems.discountType', defaultMessage: 'Tyyppi' },
  discountNetGross: { id: 'towingRecordItems.discountNetGross', defaultMessage: 'Alennus (netto/brutto)' },
  netAmount: { id: 'towingRecordItems.netAmount', defaultMessage: 'Veroton summa' },
  vat: { id: 'towingRecordItems.vat', defaultMessage: 'ALV' },
  unitPriceShort: { id: 'towingRecordItems.unitPriceShort', defaultMessage: 'Yks. hinta' },
  discountShort: { id: 'towingRecordItems.discountShort', defaultMessage: 'Ale' },
  vatAmount: { id: 'towingRecordItems.vatAmount', defaultMessage: 'Veron määrä' },
})
